<div mat-dialog-title class="ds">
  <span>{{pageTitle}}</span>
  <button mat-icon-button class="close-dialog-button" (click)="cancel()">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="content-ds" [ngClass]="{ 'mobile': isMobile, 'desktop': !isMobile }">
  @if (isLoadingContacts || isLoadingCustomers || !isTouchpointLoaded || !accountManagersLoaded) {
    <div class="content-container loading-spinner-container">
      <ds-progress-spinner></ds-progress-spinner>
    </div>
  }
  @if (!isLoadingContacts && !isLoadingCustomers && isTouchpointLoaded && accountManagersLoaded) {
    <div class="content-container">
      <form id="touchpointForm" class="touchpoint-form" [formGroup]="touchpointForm">

        <div class="header-fields-row">
          @if (showAccountManagerField) {
            <ds-autocomplete
              id="accountManagerField"
              class="fill-width header-field"
              label_orientation="vertical-label"
              [label]="appStrings.quoteDetails_AccountManager"
              [options]="accountManagerOptions"
              [control]="touchpointForm.controls.accountManager"
              drop_icon="search"
              (selectionChange)="onAccountManagerSelected($event)">
            </ds-autocomplete>
          }
          @if (showAccountField) {
            <ds-autocomplete
              id="customerBpField"
              class="fill-width header-field"
              label_orientation="vertical-label"
              [label]="appStrings.label_customerBpNumber"
              [options]="customerOptions"
              [control]="touchpointForm.controls.customerBpNumber"
              drop_icon="search"
              fullFilter="true"
              (selectionChange)="onCustomerSelected($event)">
            </ds-autocomplete>
          }
          @if (!isNewTouchpoint) {
            <ds-date-picker
              id="lastTouchpointPicker"
              class="last-touchpoint-field"
              label_orientation="vertical-label"
              [label]="appStrings.label_lastTouchpoint"
              [control]="touchpointForm.controls.lastTouchpoint"
              [date_format]="dsDateFormat"
              [isDisabled]="true">
            </ds-date-picker>
          }
        </div>

        @if (contactOptionsReady && showContactsField) {
          <ds-autocomplete-chips
            class="fill-width"
            [class.no-subscript]="!getContactMessage()"
            id="contactForm"
            label_orientation="vertical-label"
            [label]="appStrings.label_contacts"
            [control]="touchpointContactCtrl"
            [options]="contactOptions"
            [additional_message]="getContactMessage()"
            [isDisabled]="isContactDisabled()">
          </ds-autocomplete-chips>
        }

        @if (showContactsField) {
          <div class="add-contact-row">
            <ds-button
              id="addContactBtn"
              [label]="appStrings.paymentDetails_create_contact"
              variant="label-icon"
              type="tertiary"
              size="medium"
              icon="add"
              iconPosition="left"
              [isDisabled]="!canAddContact"
              (onClick)="openCreateContactDialog()">
            </ds-button>
          </div>
        }

        <div class="flex-row type-subject-row">
          <ds-select
            id="touchpointTypeSelect"
            label_orientation="vertical-label"
            [label]="appStrings.label_type"
            [dropOptions]="touchpointTypes"
            [control]="touchpointForm.controls.touchpointType"
            (selectionChange)="selectTouchpointType($event)">
          </ds-select>
          <ds-textfield
            class="fill-width"
            id="subjectForm"
            label_orientation="vertical-label"
            [label]="appStrings.label_subject"
            [control]="touchpointForm.controls.subject">
          </ds-textfield>
        </div>

        <ds-textfield
          class="fill-width"
          id="locationForm"
          label_orientation="vertical-label"
          [label]="appStrings.label_location"
          [control]="touchpointForm.controls.location">
        </ds-textfield>

        <div class="flex-row date-time-row">
          <ds-date-picker
            id="startDatePicker"
            class="fill-width"
            [label]="appStrings.label_date"
            [control]="touchpointForm.controls.startDate"
            [date_format]="dsDateFormat"
            label_orientation="vertical-label">
          </ds-date-picker>
          <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
          <ds-time-picker
            id="startTimePicker"
            [fullWidth]="true"
            [label]="appStrings.startTime"
            label_orientation="vertical-label"
            [control]="touchpointForm.controls.startTime"
            (optionSelected)="updateTime()">
          </ds-time-picker>
          <ds-time-picker
            id="endTimePicker"
            [fullWidth]="true"
            [label]="appStrings.endtime"
            label_orientation="vertical-label"
            [control]="touchpointForm.controls.endTime"
            (optionSelected)="updateTime()">
          </ds-time-picker>
        </div>

        <div class="flex-row alarm-recurring-row">
          <ds-select
            class="alarm-select"
            id="alarmSelect"
            label_orientation="vertical-label"
            [label]="appStrings.label_alarm"
            [dropOptions]="alarmTypes"
            [control]="touchpointForm.controls.alarmType">
          </ds-select>
          @if (!isTaskType && !isSeriesOccurrenceEdit) {
            <ds-checkbox
              class="recurring-checkbox"
              id="recurringCheckbox"
              [label]="appStrings.label_recurring"
              [control]="touchpointForm.controls.recurring"
              [isDisabled]="isMergingToCrm"
              (change)="onRecurringChange()">
            </ds-checkbox>
          }
        </div>

        @if (touchpointForm.controls.recurring.value && !isTaskType && !isSeriesOccurrenceEdit) {
          <div class="flex-row recurrence-row" [class.weekdays-error-visible]="showWeekdaysError">
            <ds-textfield
              class="recurrence-interval"
              id="recurrenceIntervalField"
              label_orientation="vertical-label"
              [label]="appStrings.label_every"
              [control]="touchpointForm.controls.recurrenceInterval">
            </ds-textfield>
            <ds-select
              class="recurrence-unit"
              id="recurrencePatternSelect"
              label_orientation="vertical-label"
              [label]="''"
              [dropOptions]="recurrencePatternOptions"
              [control]="touchpointForm.controls.recurrencePattern">
            </ds-select>
            @if (touchpointForm.controls.recurrencePattern.value === 'Weekly') {
              <div class="weekdays-field" [class.readonly]="isMergingToCrm">
                <ds-button-toggle-legacy
                  class="weekdays-toggle"
                  [toggleValues]="weekDays"
                  type="outlined"
                  size="medium"
                  [isMultipleSelection]="true"
                  [value]="selectedDays"
                  (onClick)="onDayToggle($event)">
                </ds-button-toggle-legacy>
                @if (showWeekdaysError) {
                  <span class="recurrence-days-error">{{ appStrings.touchpoints_selectAtLeastOneDay }}</span>
                }
              </div>
            }
            @if (touchpointForm.controls.recurrencePattern.value === 'AbsoluteMonthly') {
              <ds-textfield
                class="recurrence-day-of-month"
                id="dayOfMonthField"
                label_orientation="vertical-label"
                [label]="appStrings.label_dayOfMonth"
                [control]="touchpointForm.controls.dayOfMonth">
              </ds-textfield>
            }
            <ds-divider class="vertical-divider" [vertical]="true"></ds-divider>
            <ds-date-picker
              id="recurrenceEndDatePicker"
              [label]="appStrings.label_until"
              label_orientation="vertical-label"
              [min]="recurrenceEndMinDate"
              [control]="touchpointForm.controls.recurrenceEndDate"
              [date_format]="dsDateFormat">
            </ds-date-picker>
          </div>
        }

        <div class="divider-row"><ds-divider></ds-divider></div>

        <ds-multiline
          class="fill-width resizable-multiline"
          id="notesForm"
          label_orientation="vertical-label"
          [label]="appStrings.label_body"
          [control]="touchpointForm.controls.notes">
        </ds-multiline>

        @if (!isMergingToCrm) {
          <div class="divider-row"><ds-divider></ds-divider></div>
          <div class="attachment-list">
            @for (attachment of attachments; track $index) {
              <div class="attachment-row">
                <typography class="attachment-name" variant="mat-body-2" weight="bold">{{ attachment.name }}</typography>
                @if (attachment.size) {
                  <typography class="attachment-size" variant="mat-caption-1" weight="regular">
                    {{ attachment.size | fileSize }}
                  </typography>
                }
                <span class="attachment-actions">
                  @if (attachment.id) {
                    <ds-button
                      variant="icon-only"
                      type="tertiary"
                      size="medium"
                      icon="download"
                      iconStyle="material-icons-outlined"
                      [isDisabled]="isAttachmentLoading"
                      (onClick)="downloadAttachment(attachment)">
                    </ds-button>
                  }
                  <ds-button
                    variant="icon-only"
                    type="tertiary"
                    size="medium"
                    icon="delete"
                    iconStyle="material-icons-outlined"
                    [isDisabled]="isAttachmentLoading"
                    (onClick)="removeAttachment(attachment)">
                  </ds-button>
                </span>
              </div>
            }
            @if (isAttachmentLoading) {
              <div class="attachment-loading">
                <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
              </div>
            }
          </div>

          <ds-button
            id="attachFileBtn"
            [label]="appStrings.label_attachFile"
            variant="label-icon"
            type="tertiary"
            size="medium"
            icon="attach_file"
            iconPosition="left"
            [isDisabled]="isAttachmentLoading"
            (onClick)="triggerFileUpload()">
          </ds-button>
          <input #fileInput type="file" multiple class="hidden-file-input" (change)="onFileSelected($event)" />
        }

        @if (showNotes) {
          <div class="divider-row"><ds-divider></ds-divider></div>

          <ds-multiline
            class="fill-width resizable-multiline"
            id="additionalCommentsForm"
            label_orientation="vertical-label"
            [label]="appStrings.label_notes"
            [control]="noteCtrl">
          </ds-multiline>

          <ds-button
            id="addCommentBtn"
            [label]="appStrings.button_addNote"
            variant="label-icon"
            type="secondary"
            size="medium"
            icon="add"
            iconPosition="left"
            [isDisabled]="!noteCtrl.value?.trim()"
            (onClick)="addNote()">
          </ds-button>

          @for (note of touchpointNotes; track note.id) {
            <div class="comment-row">
              <ds-paper
                elevation="elevation_none"
                borderRadius="radius_S"
                outline="outlined"
                insidePaddingTop="top-spacing_XL"
                insidePaddingBottom="bottom-spacing_XL"
                insidePaddingLeft="left-spacing_L"
                insidePaddingRight="right-spacing_L">
                <div class="comment-actions">
                  <ds-button
                    [id]="'deleteComment_' + note.id"
                    variant="icon-only"
                    type="tertiary"
                    size="medium"
                    icon="delete"
                    (onClick)="deleteNote(note.id)">
                  </ds-button>
                </div>
                <div class="comment-content">
                  <typography variant="mat-caption-1" weight="bold" class="comment-row-text">{{ note.name }} - {{ note.date | date:dateTimeFormat }}</typography>
                  <typography variant="mat-body-2" weight="regular" class="comment-row-text">{{ note.detail }}</typography>
                </div>
              </ds-paper>
            </div>
          }
        }

      </form>
    </div>
  }
</div>

<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @if (!isNewTouchpoint && !isMergingToCrm) {
      <ds-button [label]="appStrings.button_delete" id="touchpointsDeleteButton" type="label-only" variant="secondary"
        (onClick)="deleteTouchpoint()" size="medium">
      </ds-button>
    }
    <ds-button [label]="appStrings.button_cancel" id="touchpointsCancelButton" (onClick)="cancel()"
      type="label-only" variant="secondary" size="medium">
    </ds-button>
    @if (isNewTouchpoint || isMergingToCrm) {
      <ds-button [label]="appStrings.button_addTouchpoint" id="touchpointsAddButton" [isDisabled]="isLoading" size="medium"
        (onClick)="createTouchpoint()" type="label-only" variant="primary">
      </ds-button>
    }
    @if (!isNewTouchpoint && !isMergingToCrm) {
      <ds-button [label]="appStrings.button_save" id="touchpointsSaveButton" [isDisabled]="isLoading" size="medium"
        (onClick)="saveTouchpoint()" type="label-only" variant="primary">
      </ds-button>
    }
  </div>
</div>

@if (isLoading) {
  <div id="loadingContainer" class="overlay full">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<ds-dialog
  [title]="appStrings.touchpoints_deleteTouchpointTitle"
  [description]="appStrings.touchpoints_deleteDescription"
  [actionButtons]="dialogDeleteButtons"
  [open]="deleteDialogOpen$">
</ds-dialog>
